import { useContext } from 'react';
import { RouterContext } from '../../router/Router';
import useMobileApp from '../../../../hooks/mobile-app/useMobileApp';

const useMobileRouter = () => {
  const { isMobileApp } = useMobileApp();
  return isMobileApp
    ? useContext(RouterContext)
    : {
        navigate: () => {},
      };
};

export default useMobileRouter;
